<span class="estimation-title" [innerHTML]="'price-range.title' | translate"></span>
@if (loading) {
  <p-skeleton width="22rem" height="2rem"></p-skeleton>
} @else {
  <span class="estimation-amounts">
    <span class="estimation-total">{{
      'price-range.total-including' | translate: { amount: total | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }
    }}</span>
    <span class="estimation-installation">{{
      'price-range.installation-amount'
        | translate: { amount: installation | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }
    }}</span>
  </span>
}
<span class="estimation-caption" [innerHTML]="'price-range.caption' | translate"></span>
<div class="estimation-actions">
  <ng-content></ng-content>
</div>
